import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  cancelOutgoingFriendRequest,
  deleteCurrentFriend,
  friendRequestResponse,
  getFriendRequestCount,
  getSuggestedFriendsStart,
  loadFriendsStart,
  addFriendStart,
  clearSuggestedFriends,
  acknowledgeSuccessfulFriendRequest,
} from '../redux/modules/friends'
import MyFriends from '../components/community/MyFriends'
import { Article } from '../components/common/Layout'
import { Card } from '@foodsby/nutrient'
import URLSearchParams from 'url-search-params'
import { SuccessModal } from '../components/success-modal/SuccessModal'

export class PageFriends extends Component {
  successMessages = [
    `The s'more, the merrier!`,
    `What a 🍐!`,
    `We value friendchip!`,
  ]
  successMessage = this.successMessages[
    Math.floor(Math.random() * this.successMessages.length)
  ]

  componentDidMount() {
    const {
      friendRequestResponse,
      friends,
      getSuggestedFriendsStart,
      isLoadingFriends,
      loadFriendsStart,
    } = this.props
    const queryString = new URLSearchParams(window.location.search)
    const newFriend = queryString.get('connectionId')

    if (newFriend !== null) {
      friendRequestResponse({
        action: 'ACCEPT',
        requestId: newFriend,
      })
    }
    if (!friends && !isLoadingFriends) {
      loadFriendsStart()
    }
    getSuggestedFriendsStart()
  }

  componentWillUnmount() {
    this.props.clearSuggestedFriends()
    this.props.acknowledgeSuccessfulFriendRequest()
  }
  render() {
    const {
      loadFriendsError,
      friends,
      isLoadingFriends,
      incomingFriendRequests,
      outgoingFriendRequests,
      isLoadingFriendRequests,
      isLoadingSuggestedFriends,
      friendRequestResponse,
      friendRequestResponseError,
      friendRequestLoadingError,
      cancelOutgoingFriendRequest,
      cancelOutgoingRequestError,
      deleteCurrentFriend,
      deletingFriendError,
      isRespondingToFriendRequest,
      isCancelingOutgoingRequest,
      suggestedFriends,
      addFriendStart,
      getSuggestedFriendsStart,
      isWebpSupported,
      friendRequestSuccess,
      friendRequestResponseType,
      acknowledgeSuccessfulFriendRequest,
    } = this.props
    return (
      <Article>
        {friendRequestSuccess && friendRequestResponseType === 'ACCEPT' && (
          <SuccessModal
            message={'You’re now friends!'}
            onClose={acknowledgeSuccessfulFriendRequest}
            title={this.successMessage}
          />
        )}
        <Card className="friend-manager">
          <MyFriends
            addFriendStart={addFriendStart}
            cancelOutgoingFriendRequest={cancelOutgoingFriendRequest}
            cancelOutgoingRequestError={cancelOutgoingRequestError}
            deleteCurrentFriend={deleteCurrentFriend}
            deletingFriendError={deletingFriendError}
            friendRequestLoadingError={friendRequestLoadingError}
            friendRequestResponse={friendRequestResponse}
            friendRequestResponseError={friendRequestResponseError}
            friends={friends}
            getSuggestedFriendsStart={getSuggestedFriendsStart}
            incomingFriendRequests={incomingFriendRequests}
            isCancelingOutgoingRequest={isCancelingOutgoingRequest}
            isLoadingFriendRequests={isLoadingFriendRequests}
            isLoadingFriends={isLoadingFriends}
            isLoadingSuggestedFriends={isLoadingSuggestedFriends}
            isRespondingToFriendRequest={isRespondingToFriendRequest}
            isWebpSupported={isWebpSupported}
            loadFriendsError={loadFriendsError}
            outgoingFriendRequests={outgoingFriendRequests}
            suggestedFriends={suggestedFriends}
          />
        </Card>
      </Article>
    )
  }
}
const mapStateToProps = state => {
  const {
    isLoadingFriends,
    loadFriendsError,
    incomingFriendRequests,
    friends,
    deletingFriendError,
    outgoingFriendRequests,
    isLoadingFriendRequests,
    isLoadingSuggestedFriends,
    friendRequestResponseError,
    friendRequestLoadingError,
    cancelOutgoingRequestError,
    isRespondingToFriendRequest,
    isCancelingOutgoingRequest,
    suggestedFriends,
    friendRequestSuccess,
    friendRequestResponseType,
  } = state.friends
  const { isWebpSupported } = state.browser
  return {
    isLoadingFriends,
    loadFriendsError,
    incomingFriendRequests,
    deletingFriendError,
    friends,
    outgoingFriendRequests,
    isLoadingFriendRequests,
    isLoadingSuggestedFriends,
    friendRequestResponseError,
    friendRequestLoadingError,
    cancelOutgoingRequestError,
    isRespondingToFriendRequest,
    isCancelingOutgoingRequest,
    suggestedFriends,
    isWebpSupported,
    friendRequestSuccess,
    friendRequestResponseType,
  }
}
const mapDispatchToProps = {
  cancelOutgoingFriendRequest,
  deleteCurrentFriend,
  friendRequestResponse,
  getFriendRequestCount,
  getSuggestedFriendsStart,
  loadFriendsStart,
  addFriendStart,
  clearSuggestedFriends,
  acknowledgeSuccessfulFriendRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageFriends)
